import React, { useState, useEffect } from "react";

export default function Blogs() {
useEffect(() => {
    document.title = "Blogs | Deveopment Solutions";
    }, []);
  const [selectedBlog, setSelectedBlog] = useState(null);

  const featuredBlog = {
    title: "How AI is Transforming Web Development in 2025",
    excerpt:
      "AI is revolutionizing how we build software. From code generation to predictive UX, here’s what’s coming next…",
    content: `AI is dramatically changing the landscape of web development. With advanced AI tools, developers can now generate code faster, optimize user experience dynamically, and even predict user behavior using machine learning.

This shift is not just about automation, but about smarter decision-making and creating truly personalized web experiences. Companies adopting AI-driven workflows are seeing improved productivity, reduced bugs, and more innovative solutions.

In 2025, expect AI-assisted design, chatbots that feel human, and fully adaptive websites that evolve as users interact.`,
    img: "https://images.pexels.com/photos/3861958/pexels-photo-3861958.jpeg?auto=compress&cs=tinysrgb&w=1600",
    author: "Omar Arshad",
    date: "July 15, 2025",
  };

  const blogs = [
    {
      title: "Why Cloud Migration is the Future of Business",
      excerpt:
        "Moving to the cloud saves cost, improves scalability, and boosts security. Let’s dive into the real-world benefits.",
      content: `Cloud migration helps businesses reduce infrastructure costs while improving reliability and scalability.

By moving legacy systems to AWS, Azure, or Google Cloud, companies gain instant access to enterprise-level security, automatic scaling, and global accessibility.

The future is hybrid & multi-cloud strategies, allowing organizations to pick the best of each platform.`,
      img: "https://images.pexels.com/photos/3861972/pexels-photo-3861972.jpeg?auto=compress&cs=tinysrgb&w=800",
      author: "Dev Sols Team",
      date: "July 10, 2025",
    },
    {
      title: "10 UX Principles Every App Should Follow",
      excerpt:
        "Great UX is more than beautiful screens. It’s about creating intuitive journeys for your users.",
      content: `A great UX is not just about design aesthetics but about clarity, simplicity, and delight.

Key principles include:
- Clear navigation
- Consistent design system
- Accessibility for all users
- Fast load times
- Personalization without intrusion`,
      img: "https://images.pexels.com/photos/3184431/pexels-photo-3184431.jpeg?auto=compress&cs=tinysrgb&w=800",
      author: "Dev Sols Team",
      date: "June 30, 2025",
    },
    {
      title: "Boosting SEO for Startups: A Quick Guide",
      excerpt:
        "SEO can make or break a startup’s online presence. Here’s how you can rank better even with a small budget.",
      content: `SEO is crucial for startups to get noticed. Simple steps include:
- Writing keyword-rich blogs
- Optimizing page speed
- Building backlinks
- Using schema markup`,
      img: "https://images.pexels.com/photos/3861975/pexels-photo-3861975.jpeg?auto=compress&cs=tinysrgb&w=800",
      author: "Dev Sols Team",
      date: "June 25, 2025",
    },
    {
      title: "React vs Next.js – Which One Should You Choose?",
      excerpt:
        "Both React and Next.js are popular, but when to choose which? Let’s break it down for developers and businesses.",
      content: `React is a powerful UI library, while Next.js adds SSR, SEO improvements, and routing out-of-the-box. For SEO-heavy apps, Next.js is better; for pure SPAs, React works fine.`,
      img: "https://images.pexels.com/photos/1181269/pexels-photo-1181269.jpeg?auto=compress&cs=tinysrgb&w=800",
      author: "Dev Sols Team",
      date: "June 20, 2025",
    },

    // ✅ Adding 26 more blogs for rich content
    {
      title: "Laravel 11 Features You Must Know",
      excerpt:
        "Laravel 11 brings improved performance, better routing, and async queues. Let’s explore what’s new.",
      content: `Laravel 11 introduces lightweight service containers, improved task scheduling, and first-class support for Octane. It’s the perfect framework for modern scalable apps.`,
      img: "https://images.pexels.com/photos/574071/pexels-photo-574071.jpeg",
      author: "Dev Sols Team",
      date: "June 15, 2025",
    },
    {
      title: "Top 5 Mistakes When Building a Startup MVP",
      excerpt:
        "Launching an MVP? Avoid these costly mistakes that can kill your startup before it begins.",
      content: `Many startups fail because they build too much too soon. Focus on:
- Solving ONE core problem
- Validating market fit
- Avoiding over-engineering`,
      img: "https://images.pexels.com/photos/3184460/pexels-photo-3184460.jpeg",
      author: "Dev Sols Team",
      date: "June 10, 2025",
    },
    {
      title: "Mastering Tailwind CSS for Faster UI Development",
      excerpt:
        "Tailwind CSS is the new favorite for developers. Here’s how to use it for rapid UI creation.",
      content: `Tailwind CSS lets you build responsive UI without writing tons of custom CSS. Combine it with reusable components and you’ll speed up frontend development by 50%.`,
      img: "https://images.pexels.com/photos/1181244/pexels-photo-1181244.jpeg",
      author: "Dev Sols Team",
      date: "June 8, 2025",
    },
    {
      title: "AI Chatbots for Businesses: Are They Worth It?",
      excerpt:
        "ChatGPT-like AI bots can boost sales & support. But are they always the right choice?",
      content: `AI chatbots reduce human support load, answer FAQs instantly, and improve conversion rates. However, they must be trained properly to avoid frustrating users.`,
      img: "https://images.pexels.com/photos/1181353/pexels-photo-1181353.jpeg",
      author: "Dev Sols Team",
      date: "June 5, 2025",
    },
    {
      title: "Building a Scalable SaaS with Multi-Tenancy",
      excerpt:
        "Multi-tenancy is crucial for SaaS. Here’s how to implement it without overcomplicating your architecture.",
      content: `Use a central auth DB, tenant-based schemas, and modular code. Laravel + PostgreSQL works great for multi-tenant SaaS apps.`,
      img: "https://images.pexels.com/photos/3184357/pexels-photo-3184357.jpeg",
      author: "Dev Sols Team",
      date: "May 28, 2025",
    },
    {
      title: "Why Startups Should Adopt Agile Development",
      excerpt:
        "Agile isn’t just for big companies. It can save startups time & money too.",
      content: `Agile lets you build iteratively, validate features quickly, and adapt to user feedback instead of wasting months on unnecessary features.`,
      img: "https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg",
      author: "Dev Sols Team",
      date: "May 25, 2025",
    },
    {
      title: "State Management in React – Redux vs Zustand vs Context API",
      excerpt:
        "Confused about state management? Let’s break down when to use which solution.",
      content: `Redux is great for complex apps, Context for small ones, and Zustand is a lightweight alternative for medium apps.`,
      img: "https://images.pexels.com/photos/270404/pexels-photo-270404.jpeg",
      author: "Dev Sols Team",
      date: "May 15, 2025",
    },
    {
      title: "How Startups Can Use AI for Competitive Advantage",
      excerpt:
        "AI isn’t just for big tech. Startups can leverage it too. Here’s how.",
      content: `AI can automate tasks, analyze market data, and improve decision-making. Start with AI-driven analytics & chatbots.`,
      img: "https://images.pexels.com/photos/3861958/pexels-photo-3861958.jpeg",
      author: "Dev Sols Team",
      date: "May 10, 2025",
    },
    {
      title: "Docker for Beginners: Why Every Developer Should Learn It",
      excerpt:
        "Docker makes deployment easier. Here’s a simple intro for beginners.",
      content: `Docker lets you package apps with all dependencies, ensuring consistent environments across dev & prod.`,
      img: "https://images.pexels.com/photos/267614/pexels-photo-267614.jpeg",
      author: "Dev Sols Team",
      date: "May 8, 2025",
    },
    {
      title: "GraphQL vs REST: Which API Style is Better?",
      excerpt:
        "Both are great, but they serve different needs. Here’s how to choose.",
      content: `GraphQL gives flexibility in queries. REST is simpler and cache-friendly. Use GraphQL for complex data needs.`,
      img: "https://images.pexels.com/photos/1181263/pexels-photo-1181263.jpeg",
      author: "Dev Sols Team",
      date: "April 28, 2025",
    },
  ];

  return (
    <>
      {/* HERO SECTION */}
      <section
        className="relative h-[50vh] flex items-center justify-center text-center"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/1181353/pexels-photo-1181353.jpeg?auto=compress&cs=tinysrgb&w=1600')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="relative z-10 px-6">
          <h1 className="text-5xl md:text-6xl font-bold text-white">
            Our Blog
          </h1>
          <p className="mt-4 text-lg text-gray-200 max-w-2xl mx-auto">
            Insights, stories & trends from the world of technology, business,
            and digital innovation.
          </p>
        </div>
      </section>

      {/* FEATURED BLOG */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <h2
            className="text-4xl font-bold mb-8 text-center"
            style={{ color: "#414042" }}
          >
            Featured <span style={{ color: "#1b75bc" }}>Article</span>
          </h2>

          <div className="grid md:grid-cols-2 gap-8 items-center">
            <img
              src={featuredBlog.img}
              alt={featuredBlog.title}
              className="w-full rounded-lg shadow-lg"
            />

            <div>
              <h3
                className="text-2xl font-bold mb-4"
                style={{ color: "#1b75bc" }}
              >
                {featuredBlog.title}
              </h3>
              <p className="text-gray-600 mb-4">{featuredBlog.excerpt}</p>
              <div className="flex items-center text-sm text-gray-500">
                <span>✍ {featuredBlog.author}</span>
                <span className="mx-3">|</span>
                <span>{featuredBlog.date}</span>
              </div>
              <button
                onClick={() => setSelectedBlog(featuredBlog)}
                className="inline-block mt-5 px-6 py-3 rounded-md text-white font-medium"
                style={{ backgroundColor: "#1b75bc" }}
              >
                Read More →
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG GRID */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2
            className="text-4xl font-bold mb-12 text-center"
            style={{ color: "#414042" }}
          >
            Latest <span style={{ color: "#1b75bc" }}>Articles</span>
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            {blogs.map((blog, idx) => (
              <div
                key={idx}
                className="bg-white rounded-lg shadow hover:shadow-lg transition overflow-hidden"
              >
                <img
                  src={blog.img}
                  alt={blog.title}
                  className="w-full h-56 object-cover"
                />
                <div className="p-5">
                  <h3
                    className="text-lg font-bold mb-2"
                    style={{ color: "#1b75bc" }}
                  >
                    {blog.title}
                  </h3>
                  <p className="text-gray-600 text-sm">{blog.excerpt}</p>
                  <div className="flex justify-between items-center mt-4 text-sm text-gray-500">
                    <span>{blog.author}</span>
                    <span>{blog.date}</span>
                  </div>
                  <button
                    onClick={() => setSelectedBlog(blog)}
                    className="inline-block mt-4 text-sm font-medium"
                    style={{ color: "#1b75bc" }}
                  >
                    Read More →
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* MODAL */}
      {selectedBlog && (
        <div
          className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50"
          onClick={() => setSelectedBlog(null)}
        >
          <div
            className="bg-white max-w-3xl w-full rounded-lg shadow-lg p-6 relative transform transition-all duration-300 scale-95 opacity-0 animate-fadeIn"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedBlog.img}
              alt={selectedBlog.title}
              className="w-full h-64 object-cover rounded"
            />
            <div className="mt-5">
              <h2 className="text-2xl font-bold" style={{ color: "#1b75bc" }}>
                {selectedBlog.title}
              </h2>
              <div className="text-sm text-gray-500 mt-1">
                ✍ {selectedBlog.author} • {selectedBlog.date}
              </div>
              <p className="mt-4 text-gray-700 whitespace-pre-line leading-relaxed">
                {selectedBlog.content}
              </p>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeIn {
          0% { opacity: 0; transform: scale(0.95); }
          100% { opacity: 1; transform: scale(1); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out forwards;
        }
      `}</style>
    </>
  );
}
